// extracted by mini-css-extract-plugin
export default {"main":"_60d6f65432","tit":"_2993bb31f9","maintitle":"cb47029563","ylw":"_26ce56f80d","white":"eb6a5af914","mv_title":"_7dd2fce82c","mv_nc":"a3bc3af902","mv_in":"af7bfb16d1"};